<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    z-index="100"
  >
    <span>{{ message }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="cancelButtonVisible" @click="cancelButtonClick">{{ cancelButtonText }}</el-button>
      <el-button type="primary" @click="okButtonClick">{{ okButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable */
export default {
  name: "full-screen-dialog",
  props: {
    title: {
      type: String,
      required: false,
      default: "提示",
    },
    message: {
      type: String,
      required: false,
      default: "消息",
    },
    width: {
      type: String,
      required: false,
      default: "30%",
    },
    cancelButtonVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    okButtonText: {
      type: String,
      required: false,
      default: "确 定",
    },
    cancelButtonText: {
      type: String,
      required: false,
      default: "取 消",
    },
  },
  computed: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    okButtonClick() {
      this.$emit("okButtonClick");
      this.dialogVisible = false;
    },
    cancelButtonClick() {
      this.$emit("cancelButtonClick");
      this.dialogVisible = false;
    },
    show() {
      this.dialogVisible = true;
    },
  },
};
</script>